// extracted by mini-css-extract-plugin
var _1 = "FEEzI";
export { _1 as "base" }
